import { render, staticRenderFns } from "./CoachDetail.vue?vue&type=template&id=572b9c70&scoped=true"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"
import style0 from "./CoachDetail.vue?vue&type=style&index=0&id=572b9c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b9c70",
  null
  
)

export default component.exports